export default "__VITE_ASSET__DJlzAN0b__"